{
  "zh-TW": {
    "baseBtn": {
      "labels": {
        "loading": "Please wait..."
      }
    }
  }
}
